import type { ReactNode } from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";

export async function copyText(value: string) {
  try {
    await navigator.clipboard.writeText(value);
    toast.success(`Copied ${value}`);
  } catch {
    toast.error("Couldn't copy. Select the text and copy it instead.");
  }
}

export function CopyButton({ value, label }: { value: string; label?: string }) {
  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); void copyText(value); }}
      className="inline-flex rounded p-0.5 text-muted-foreground hover:bg-muted hover:text-foreground"
      aria-label={`Copy ${label ?? value}`}
      title={`Copy ${value}`}
    >
      <Copy className="h-3 w-3" />
    </button>
  );
}

/** An email, phone or link shown as selectable text with a copy button. */
export function ReachItem({ icon, value, label, href, copy = true }: {
  icon: ReactNode; value: string; label?: string; href?: string; copy?: boolean;
}) {
  return (
    <span className="inline-flex max-w-full items-center gap-1.5 rounded-md border bg-card py-0.5 pl-2 pr-1 text-[12.5px] [&>svg]:h-3.5 [&>svg]:w-3.5 [&>svg]:shrink-0 [&>svg]:text-muted-foreground">
      {icon}
      {href
        ? <a href={href} target="_blank" rel="noreferrer" className="min-w-0 truncate hover:underline">{value}</a>
        : <span className="min-w-0 select-all truncate tabular-nums">{value}</span>}
      {label && <span className="text-[11px] text-muted-foreground">{label}</span>}
      {copy && <CopyButton value={value} label={label} />}
    </span>
  );
}
